export enum FundsMatchingMethod {
    ByBuyerContact = 'by-buyer-contact',
    ByBuyerReference = 'by-buyer-reference',
    ByBuyerLegalName = 'by-buyer-legal-name',
    ByBuyerDisplayName = 'by-buyer-display-name',
    ByCheckoutAmount = 'by-checkout-amount',
    ByInvoiceReference = 'by-invoice-reference',
    ByCheckoutReference = 'by-checkout-reference',
    ByPaymentMethodReference = 'by-payment-method-reference',
    ByPaymentMethodProviderId = 'by-payment-method-provider-id',
    ByBuyerPredefinedMatching = 'by-buyer-predefined-matching',
    ByExistingFundPayerName = 'by-existing-fund-payer-name',
    ByExistingFundPayerNameAndReference = 'by-existing-fund-payer-name-and-reference',
}
